import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import {
  Edit as IconEdit,
  PictureAsPdf as IconPdf,
  Article as IconFile,
} from "@mui/icons-material";

import Loader from "components/Custom/Loader";
import { ApiMasters } from "apihandlers//masters/masters";
import { ApiIndents } from "apihandlers//indent";
import { NOTIFY, DEFAULTS, FORMATS } from "common/config";
import { COLORS } from "common/colors";
import { LABELS, ERRORS, WARNINGS, SUCCESS, SUB_TITLES } from "common/labels";
import Btn from "components/Custom/Btn";
import TxtBox from "components/Custom/TxtBox";
import UiDialog from "components/Custom/UiDialog";
import { COMMON_JS } from "common/scripts";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";
import { DateFunctions } from "common/datefunctions";

const ApiMastersHandler = new ApiMasters();
const ApiIndentHandler = new ApiIndents();

const ReturnRequest = (props: any) => {
  const { setDashMenu } = props;
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any>(null);

  const [isSubmit, setIsSubmit] = useState(false);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  const indentIdRef: any = useRef();
  const chargedIdRef: any = useRef();
  const driverIdRef: any = useRef();

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
  };

  const getRows = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };
    ApiIndentHandler.getReturnPickups(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
        console.log("Rows", list);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  const manageRecord = () => {
    const name = (
      document.getElementById("name") as HTMLInputElement
    ).value.trim();

    // Validations
    let errors = [];
    if (name == "") {
      errors.push({
        id: "name",
        msg:
          "<span class='bold'>" +
          LABELS.ENTER_RETURN_REQUEST +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      returnPickupStatus: "REQUESTED",
      //   enteredDate: "",
      pickupPoint: 2,
      comments: name,
      activeStatus: "true",
      //   commentsByApprover: "",
      //   approvedById: "",
      //   approvedDate: "",
    };
    setIsSubmit(true);
    ApiIndentHandler.manageReturnPickup(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      frozen: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "pickupPointArea",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PICKUP_POINT,
      width: "20%",
    },
    {
      key: "enteredByUser",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ENTERED_BY,
      width: "15%",
    },
    {
      key: "enteredDate",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DATE,
      width: "15%",
    },
    {
      key: "comments",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.COMMENTS,
      width: "30%",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "10%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li
            onClick={() => {
              setDashMenu(LABELS.HOME);
            }}
          >
            {LABELS.TRANSACTIONS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{LABELS.RETURN_REQUEST}</li>
        </ul>
        <h4>{LABELS.RETURN_REQUEST}</h4>
        <p className="SubTitles">{SUB_TITLES.RETURN_REQUEST}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.RETURN_REQUEST}
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.RETURN_REQUEST}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>
      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.RETURN_REQUEST + ": " + selectedRow.name
              : "Add New " + LABELS.RETURN_REQUEST
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup red">
            <label>
              {LABELS.ENTER_RETURN_REQUEST} {<span className="red">*</span>}
            </label>
            <TxtBox
              id={"name"}
              placeholder={LABELS.ENTER_RETURN_REQUEST}
              defaultValue={selectedRow.comments}
              disabled={isSubmit}
            />
          </div>

          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          <div className="formGroup submitBtnWrapper">
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
                loading={isSubmit}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageRecord}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(ReturnRequest);
